import styled from 'styled-components'

import { _S_Medium, desktopMediaQuery, mainColors } from '@avantstay/backoffice-core'

import { ItemProps } from '@new/__global/components/OmniSearch/OmniSearch.types'

import Link from '@sharedComponents/Link'

export const Item = styled.button<ItemProps>`
  padding: 8px 24px;
  display: flex;
  width: 100%;
  text-align: left;
  position: relative;
  outline: none;
  background: ${props => (props.isFocused ? mainColors.accentExtraLight : mainColors.white)};

  ${desktopMediaQuery`
    padding-left: 16px;
    padding-right: 16px;
  `}

  &::before {
    content: '';
    width: 4px;
    background: ${props => (props.isFocused ? mainColors.accentMedium : 'transparent')};
    position: absolute;
    height: 100%;
    display: inline-block;
    left: 0;
    top: 0;
  }

  &:hover,
  &:focus {
    background: ${mainColors.neutralExtraLight};

    &:before {
      background: ${mainColors.accentMedium};
    }
  }
`

export const ViewAll = styled(Link)`
  ${_S_Medium};
  margin: 14px 24px 0;

  ${desktopMediaQuery`
    margin: 0 16px;
  `}
`
